import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Ticker } from 'app/interfaces/ticker';
import { concat, Observable, of, Subject, Subscription } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { CoreMenuService } from '@core/components/core-menu/core-menu.service';
import { CryptoService } from 'app/sections/crypto/services/crypto.service';
import { ToastService } from 'app/components/toasts/toasts.service';

@Component({
  selector: 'app-crypto-search',
  templateUrl: './crypto-search.component.html',
  styleUrls: ['./crypto-search.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CryptoSearchComponent implements OnInit, OnDestroy {

  public tickers$: Observable<any>;
  public tickerInput$ = new Subject<string>();
  private _unsubscribeAll: Subject<any>;
  public selectedTicker: string = null;
  public tikcerLoading: boolean = false;
  private tickerSubscription: Subscription = null;
  constructor(
    private cryptoService: CryptoService, 
    private _coreMenuService: CoreMenuService,
    private toast:ToastService) { 
    this._unsubscribeAll = new Subject();
  }

  ngOnInit(): void {
    this.cryptoService.selectedTickerInfo.pipe(takeUntil(this._unsubscribeAll)).subscribe((ticker: Ticker)=>{
      if(ticker){
        this.selectedTicker = ticker.ticker;
        this.tickers$ = of([ticker]);
        const menu = this._coreMenuService.getMenu('crypto');
        this.enableMenu(menu);
        this._coreMenuService.setCurrentMenu('crypto')  
      } else {
        this.selectedTicker = null;
        this.tikcerLoading = false;
        this.tickers$ = of([]);
      }
    });

    this.tickerInput$.pipe(takeUntil(this._unsubscribeAll)).subscribe((value) => {
      this.unsubCollectionApi();
      this.tickerSubscription = this.getTickersData(value).subscribe();
    });
  }

  trackByFn(item: any) {
    return item.id;
  }

  getTickersData(term: string = null): Observable<any> {
    if(term && term.length >= 3){
      this.tikcerLoading = true;
      term = term.toLowerCase();
      return this.cryptoService.getCryptoPagination(1,10,term).pipe(
        map((resp: any) =>{
          this.tikcerLoading = false;
          this.tickers$ = concat(of(resp.data));
          return resp;
        })
      )
    } else {
      this.tikcerLoading = false;
      return of([]);
    }
  }

  tickerChange(ticker){
    if(ticker){
      this.cryptoService.getCryptoTickerByName(ticker).toPromise().then((result:any)=>{
        if(result.code == 1001){
          const menu = this._coreMenuService.getMenu('crypto');
          this.enableMenu(menu);
          this._coreMenuService.setCurrentMenu('crypto');
          this.cryptoService.setCryptoTicker(result.data);
          // this.router.navigateByUrl('/crypto/summary')
        } else {
          this.toast.show(`This Ticker is for permium`, {
            delay: 2000,
            classname: 'bg-primary text-light',
            autohide: true
          });
        }
      });
    }
  }

  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }

  enableMenu(menu){
    menu.forEach(element => {
      if(element.hasOwnProperty('disabled')){
        element.disabled = false;
      }
      if(element.hasOwnProperty('children')){
        this.enableMenu(element.children)
      }
    });

    return menu;
  }

  private unsubCollectionApi(){
    if( this.tickerSubscription ) { this.tickerSubscription.unsubscribe(); }
  }

}
